import { render, staticRenderFns } from "./pay_config.vue?vue&type=template&id=6f8ddfc4&scoped=true"
import script from "./pay_config.vue?vue&type=script&lang=js"
export * from "./pay_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ddfc4",
  null
  
)

export default component.exports